/* DSL ATC A/B — drie button-text variants */
(function(){
  if (!window.DSL_AB) return;
  var VARIANTS = {A: "In winkelwagen", B: "Voeg toe aan mijn routine", C: "Bestel — gratis verzending vanaf €99"};
  var v = window.DSL_AB.getVariant("atc_text_v1", ["A","B","C"]);
  function apply(){
    document.querySelectorAll("[data-atc-text-target], button.product-form__submit, .add-to-cart-button, [name=add]").forEach(function(b){
      if (b.dataset.atcAbApplied) return;
      var span = b.querySelector("span:not(.loading-overlay__spinner)") || b;
      var orig = span.textContent.trim();
      // Only override if the original is the default Dutch label
      if (/^(In winkelwagen|Toevoegen|Add to cart)$/i.test(orig)) {
        span.textContent = VARIANTS[v];
        b.dataset.atcAbApplied = "1";
        b.dataset.atcAbVariant = v;
      }
    });
  }
  if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", apply);
  else apply();
  if ("MutationObserver" in window) new MutationObserver(apply).observe(document.body, {childList: true, subtree: true});
  document.addEventListener("submit", function(e){
    var f = e.target;
    if (!f.action || f.action.indexOf("/cart/add") === -1) return;
    if (window.DSL_AB) window.DSL_AB.track("atc_submit", {variant: v});
  }, true);
})();